import React, { PureComponent } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';

import CareersDepartment from './CareersDepartment.js';

const TeamList = DisplayComponent(
  class TeamList extends PureComponent {
    render() {
      return (
        <div>
          <h1>Team List: {this.props.name}</h1>
          <CareersDepartment name={this.props.name} jobs={this.props.jobs} />
        </div>
      );
    }
  }
);

export default TeamList;
